
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.136 3.843c.623-1.79 3.156-1.79 3.778 0l.946 2.72a2 2 0 001.848 1.343l2.88.06c1.895.038 2.678 2.447 1.167 3.592l-2.295 1.74a2 2 0 00-.706 2.173l.834 2.757c.549 1.815-1.5 3.303-3.057 2.22l-2.364-1.645a2 2 0 00-2.284 0l-2.364 1.645c-1.557 1.084-3.606-.405-3.057-2.22l.834-2.757a2 2 0 00-.706-2.173l-2.295-1.74c-1.51-1.145-.728-3.554 1.168-3.593l2.879-.059A2 2 0 009.19 6.564l.946-2.72z"}})])
          )
        }
      }
    